import styled from 'styled-components'

import { RowSpaceBetween } from 'components/common'

const Container = styled(RowSpaceBetween)`
  display: flex;
  margin-right: 20px;
  flex-grow: 2;
`

const NavItem = styled.nav`
  display: flex;
  flex-direction: row;
  align-items: center;
  text-align: center;
  transition: transform 0.4s ease-in-out;
`

export { Container, NavItem }
